<div class="container">
    <div class="row align-items-center">
        <!-- Left-aligned Back button -->
        <div class="col-auto">
            <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back"
                *ngIf="globals.isPaymentDetails" (click)="GetBack()">
                <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
            </button>
        </div>

        <!-- Centered Transaction Details -->
        <div class="col text-center">
            <h2 class="fontsizeandfamilySans">Transaction Details</h2>
        </div>

        <!-- Empty column to balance layout -->
        <div class="col-md-1"></div>
    </div>
    <!-- Payment Details -->
    <div *ngIf="customDetails">
        <strong class="fontsizeandfamilyCalibri">Payment Details</strong>
        <table class="details-table fontsizeandfamilyCalibri" style="background-color: #e3ebdc;">
            <tr *ngFor="let key of objectKeys(customDetails)">
                <td class="key-column">{{ key }}</td>
                <td class="value-column">{{ customDetails[key] }}</td>
            </tr>
        </table>
    </div>

    <!-- Payment Info -->
    <div *ngIf="paymentDetails">
        <strong class="fontsizeandfamilyCalibri">Payment</strong>
        <table class="details-table fontsizeandfamilyCalibri" style="background-color: #e3ebdc;">
            <tr *ngFor="let key of objectKeys(paymentDetails)">
                <td class="key-column">{{ key }}</td>
                <td class="value-column">{{ paymentDetails[key] }}</td>
            </tr>
        </table>
    </div>

    <!-- Order Info -->
    <div *ngIf="orderDetails">
        <strong class="fontsizeandfamilyCalibri">Order</strong>
        <table class="details-table fontsizeandfamilyCalibri" style="background-color: #e3ebdc;">
            <tr *ngFor="let key of objectKeys(orderDetails)">
                <td class="key-column">{{ key }}</td>
                <td class="value-column">{{ orderDetails[key] }}</td>
            </tr>
        </table>
    </div>
</div>